import { Input } from 'components/form';
import React, { useEffect, useState } from 'react';
import { Search as SearchIcon } from 'components/Icons';
import { Container, Search, ListItem, List } from './EnvOptionsStyles';
import { DataEnvironment } from 'types/DataEnvironment';

type Props = {
  active: DataEnvironment;
  options: DataEnvironment[];
  onChange: (value: DataEnvironment) => void;
};
const EnvOptions: React.FC<Props> = ({ options, onChange, active }) => {
  const [data, setData] = useState<DataEnvironment[]>([]);

  useEffect(() => {
    setData(options);
  }, []);

  const onSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value.toLowerCase();
    const filtered = options.filter(
      (item) => item.name.toLowerCase().indexOf(value) >= 0
    );
    setData(filtered);
  };

  return (
    <Container>
      <Search>
        <Input
          icon={<SearchIcon fill='#8795A2' size='14px' />}
          onChange={onSearch}
          placeholder="Search environments"
        />
      </Search>
      <List>
          {data.map((item) => (
            <ListItem key={item.id} active={item.id === active.id} onClick={() => onChange(item)}>{item.name}</ListItem>
          ))}
        </List>
    </Container>
  );
};

export default EnvOptions;
